var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 127 127",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#726fb3",
    d: "M125.58,56.69L71.16,5.39c-2.04-1.93-4.76-2.99-7.66-2.99s-5.62,1.06-7.66,2.99L1.42,56.69C.51,57.56,0,58.7,0,59.93s.51,2.37,1.42,3.24c1.89,1.78,4.97,1.78,6.87,0l5.68-5.35v53.83c0,7.14,6.16,12.95,13.74,12.95h70.17c7.58,0,13.74-5.81,13.74-12.95v-55.18l7.1,6.7c.9.85,2.15,1.34,3.43,1.34s2.53-.49,3.43-1.34c1.89-1.78,1.89-4.69,0-6.47ZM101.9,47.32v64.33c0,2.1-1.81,3.8-4.03,3.8H27.71c-2.22,0-4.02-1.7-4.02-3.8v-63L62.71,11.86c.21-.2.49-.31.79-.31s.58.11.79.31l37.61,35.45Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#726fb3",
    d: "M29.42,40.28s0,0,0,0c0,0,0,0,0,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.d0c56048808b8db50d0786326cd9ff9c.svg";
export { ForwardRef as ReactComponent };